import styled from 'styled-components';

export const SimulatedInput = styled.div<{ isDarkMode: boolean }>`
  cursor: text;
  height: auto;
  padding: 1rem 0.6rem;
  font-size: 1.6rem;
  color: ${({ theme, isDarkMode }) => (isDarkMode ? theme.colors.grey[500] : theme.colors.black[500])};
  border-radius: 0.5rem;
  background-color: ${({ theme, isDarkMode }) => (isDarkMode ? theme.colors.black : theme.colors.white)};
  outline: none;
  border: 1px solid ${({ theme, isDarkMode }) => (isDarkMode ? theme.colors.secondary.lighter : theme.colors.grey[300])};
  display: flex;

  &:focus {
    border-color: ${({ theme }) => theme.colors.info.main};
  }
`;
